import { RefObject, useCallback, useRef } from 'react';

import { Stepper } from '../helpers/number-stepper';
import { NumberFormatOptions } from '../number-field.types';

export type UseStepperProps = NumberFormatOptions & {
  inputRef: RefObject<HTMLInputElement>;
};

/**
 * Custom hook to ensure a memoized instance of Stepper is created
 * and reused across renders, preventing unnecessary re-initialization.
 *
 * @param props - The properties for the stepper, including input reference and formatting options.
 * @returns A function that returns the current stepper instance.
 */
export function useStepper(props: UseStepperProps) {
  const stepperRef = useRef<Stepper | null>(null);
  return useCallback(() => {
    if (!stepperRef.current && props.inputRef.current) {
      stepperRef.current = new Stepper({ ...props, input: props.inputRef.current });
    }

    return stepperRef.current;
  }, [props]);
}
